
import { StyleSheet } from 'aphrodite';
import { defaultStyles } from '../../library';

const styles = StyleSheet.create({
    wrapper: {
        backgroundColor: defaultStyles.greyWhite,
        padding: '20px 10px 25px',
        '@media screen and (min-width: 480px)': {
            padding: '20px 10px 25px',
        },
        '@media screen and (min-width: 768px)': {
            padding: '20px 10px 40px',
        },
        '@media print': {
            padding: '20px 10px',
        },
    },
    h3: {
        marginTop: 0,
    },
    productSelector: {
        position: 'relative',
        marginBottom: '56px',
    },
    productListButtonMobile: {
        fontSize: '20px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        padding: '20px 20px',
        position: 'relative',
        border: '1px solid grey',
        '@media screen and (min-width: 990px)': {
            display: 'none',
        },
    },
    productListButtonMobileOpened: {
        backgroundColor: defaultStyles.greyLight
    },
    productListButtonMobileIcon: {
        position: 'absolute',
        right: '20px',
        top: '50%',
        transform: 'translateY(-50%)',
    },
    productListButtonMobileIconOpened: {
        transform: 'translateY(-50%) rotate(180deg)',
    },
    productList: {
        display: 'none',
        '@media screen and (min-width: 990px)': {
            display: 'flex',
            flexWrap: 'wrap',
            marginRight: '-10px',
            marginLeft: '-10px',
        },
        '@media print': {
            display: 'none',
        }
    },
    productListOpened: {
        '@media screen and (max-width: 989px)': {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            maxHeight: '320px',
            overflowY: 'auto',
            border: '1px solid ' + defaultStyles.greyLight,
        },
    },
    productContainer: {
        marginTop: '32px',
    },
    product: {
        '@media screen and (max-width: 767px)': {
            display: 'none',
        }
    },
    error: {
        marginTop: '16px',
    },
    containerError: {
        border: '1px solid ' + defaultStyles.red,
    }
});

export default styles;
